import './sorter.less';
import * as _ from 'lodash';
import { SortingGroup } from './sortHelper';

angular.module("tromanWeb").controller('GroupSortController', ['dialogService', 'orderByFilter', '$scope', 'sorterParams', function (dialogService, orderByFilter, $scope, sorterParams) {

    var self = this;
    var lastSort = null;
    var isSaving = false;

    self.sortable = {
        placeholder: 'sort-placeholder',
        axis: 'y',
        helper: function (_evt, originalItem) {
            // Clone the item instead of moving it so that the tables layout is not disturbed. (see "start")
            var ret = originalItem.clone();
            // The helper element (whether cloned or not) is outside of the tables layout
            // and so it's columns shrinks down to minimum width.
            // Set the width of all columns to the computed width of the original item.
            // If not cloning, do $(this).width($(this).width());
            var originalCols = originalItem.children().children();
            ret.children().children().each(function (index) {
                $(this).width($(originalCols[index]).innerWidth());
            });
            return ret;
        },
        start: function (_evt, ui) {
            // The placeholder is a single tbody with a single tr.
            // Set the rows height to the entire height of the moved
            // tbody as that may have multiple rows.
            ui.placeholder.children().height(ui.item.height());
            // The sortable plugin hide()s the original item while moving (if it is not also used as helper)
            // With tables, this affects the layout. Show the element and use collapse instead.
            ui.item.show();
            ui.item.css('visibility', 'collapse');
        },
        stop: function (_evt, ui) {
            // undo the work in "start".
            ui.item.css('visibility', '');
        }
    };

    $scope.$on('ui-sortable:moved', () => {
        _.each(self.groups, (x, i) => { x.$newOrder = i + 1; });
        lastSort = null;
    });

    self.sortBy = function sortBy(prop) {
        const reverse = prop === lastSort;
        self.groups = orderByFilter(self.groups, x => prop.fn(x.items[0]), reverse);
        _.each(self.groups, (x, i) => { x.$newOrder = i + 1; });
        lastSort = reverse ? null : prop;
    };

    self.groupClass = function groupClass(group) {
        if (group.placeholder) {
            return 'placeholder';
        }

        if (group.order !== group.$newOrder) {
            return "changed";
        }

        return "";
    };

    self.canSave = function () {
        return !isSaving;
    };

    self.save = function save() {

        if (!self.canSave()) return;

        isSaving = true;
        sorterParams.updateSorting(self.groups)
            .finally(function () { isSaving = false; })
            .then(function () { $scope.$close(true); })
            .catch(dialogService.error);
    };

    self.cancel = function cancel() {
        if (self.groups.some(x => x.order !== x.$newOrder)) {
            dialogService.confirm(["Det finns osparade ändringar som kommer gå förlorade.", "Är du säker?"]).then(function () {
                $scope.$dismiss("cancelled");
            });
        } else {
            $scope.$dismiss("cancelled");
        }
    };

    self.removePlaceholder = function removePlaceholder(placeholder) {
        self.groups = self.groups.filter(x => x != placeholder);
        _.each(self.groups, (x, i) => { x.$newOrder = i + 1; });
    };

    self.addPlaceholder = function addPlaceholder(before) {
        let pos = _.indexOf(self.groups, before);
        if (pos >= 0) {
            self.groups = self.groups.slice();
            self.groups.splice(pos, 0, new SortingGroup(pos + 1, null, self.def.placeholder));
            _.each(self.groups, (x, i) => { x.$newOrder = i + 1; });
        }
    };

    function init(list) {
        self.title = sorterParams.title || sorterParams.definition.title;
        self.def = sorterParams.definition;
        self.groups = _.orderBy(list, x => x.order);
        _.each(self.groups, (x, i) => { x.$newOrder = i + 1; });
    }

    sorterParams.listPromise.then(init).catch(dialogService.error);
}]);
